export const EDIT_NEFT_LOAD = 'neft/EDIT_NEFT_LOAD';
export const EDIT_NEFT_SUCCESS = 'neft/EDIT_NEFT_SUCCESS';
export const EDIT_NEFT_FAIL = 'neft/EDIT_NEFT_FAIL';
